module.exports = __webpack_public_path__ + "static/media/more-life-social-media.29313278.md";